module.exports = __webpack_public_path__ + "static/img/keke-ss-02.72ffefd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/keke/keke-ss-02.png
// module id = +byy
// module chunks = 0